export default "__VITE_ASSET__d7a26e7d__"